import React from 'react'
import EmployeeDashBoard from '../components/DashBoard/EmployeeDashBoard'
import { Navigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { ACCOUNT_TYPE_MAPPINGS } from '../utils/constants'
import { useSearchParams } from 'react-router-dom'
import { SITE_LINKS_SCHEMA } from '../router/navlinks'

const Dashboard = () => {
  const statisticDashBoardRoles = ["admin"];
  const { authInfo } = useSelector(store => store.user);
  const { userInfo } = authInfo || {};
  const { AccountType } = userInfo || {};
  const showStatisticDashBoard = statisticDashBoardRoles.includes(ACCOUNT_TYPE_MAPPINGS[(AccountType || '').toUpperCase()]?.toLowerCase());
  const [q] = useSearchParams();
  if((q.get("fromIndexRoute") === "true") && showStatisticDashBoard){
    return <Navigate to={SITE_LINKS_SCHEMA.ADMIN_DASHBOARD} />
  }
  return (
    <>
      {<EmployeeDashBoard />}
    </>
  )
}
export { Dashboard }